// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".heading[data-v-b17b07aa] {\n  font-size: 24px;\n  line-height: 40px;\n  font-weight: 500;\n  text-align: center;\n  margin-bottom: 24px;\n}\n.modal__cancel-button[data-v-b17b07aa] {\n  margin-right: 15px;\n}\n.button-bar[data-v-b17b07aa] {\n  margin-top: auto;\n}\n", ""]);
// Exports
module.exports = exports;
